import { ChatProvider } from '../../contexts/chat-context';
import { Outlet } from 'react-router';
import { ReactElement } from 'react';

export const ChatLayout = (): ReactElement => {
  return (
    <ChatProvider>
      <Outlet />
    </ChatProvider>
  );
};
